//集团化官网
// 配置API接口地址
//let domain = 'hk.group.com' //本地开发，本地测试
//let domain = 'hkmo.group.com' //本地模测
let domain=document.domain;//测试 模测 线上打包
//let domain = 'www.nbkqyy.com' 
//let apiUrl='/api'
//let apiUrl = 'http://dev.gsite.com' //本地
//let apiUrl = 'http://b.eetopintest.com';//测试
//let apiUrl = 'http://shopmo.eetop.com';//模测
let apiUrl = 'http://group-api.eetop.com';//线上
let baseURL;

const cachePrex = 'General';
console.log(domain)
if (domain.indexOf("www.hzkqyyjt.com") != -1) {
    apiUrl = 'https://group-api.hzkqyyjt.com';//线上
}
console.log(apiUrl)

if (/MSIE/i.test(navigator.appVersion) && /MSIE 9/i.test(navigator.appVersion)) { 
    baseURL = 'http://'+ document.domain + '/api'
}
else{
    baseURL = apiUrl
}

let url ='/groupfront';
//index接口相关
let indexUrl=`${url}/index`
let index={
    index:`${indexUrl}/index`,//集团配置信息
    banners:`${indexUrl}/banners`,//banner列表
    menus:`${indexUrl}/menus`,//栏目
    friendShipLinks: `${indexUrl}/friend-link-list`,
    itemSeos:`${indexUrl}/item-seos`
}
let dynamicUrl=`${url}/dynamic`
let dynamic={
    classList:`${dynamicUrl}/class-list`,//动态分类
    list:`${dynamicUrl}/list`,//动态列表
    detail:`${dynamicUrl}/detail`,//动态详情
}
let recruitUrl=`${url}/recruit`;
let recruit={
    list:`${recruitUrl}/list`,//招贤纳士列表
    detail:`${recruitUrl}/detail`,//招贤纳士详情
    workplaces:`${recruitUrl}/workplaces`,//工作地点列表
    departments:`${recruitUrl}/departments`,//专业科室列表
}
let doctorGroupUrl=`${url}/doctor-group`;
let doctorGroup={
    list:`${doctorGroupUrl}/list`,//医生列表
    detail:`${doctorGroupUrl}/detail`,//医生详情
    reservation:`${doctorGroupUrl}/reservation`,//提交预约
    symptomList:`${doctorGroupUrl}/symptom-list`,//病症列表
}
let tcCollegeUrl=`${url}/tc-college`
let tcCollege={
    classList:`${tcCollegeUrl}/class-list`,//通策牙学院文章分类
    list:`${tcCollegeUrl}/list`,//通策牙学院文章列表
    detail:`${tcCollegeUrl}/detail`,//通策牙学院文章详情
}
let aboutUrl=`${url}/about`
let about={
    intro:`${aboutUrl}/intro`,//集团介绍及企业荣誉
    subHospitals:`${aboutUrl}/sub-hospitals`,//分院介绍
    contact:`${aboutUrl}/contact`//联系我们
}

export default{
    baseURL,
    domain,
    index,
    dynamic,
    recruit,
    doctorGroup,
    tcCollege,
    about,
    cachePrex
}


// WEBPACK FOOTER //
// ./src/utils/api.js